import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = "https://wxjfkehmsofjjfamjxxx.supabase.co"
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind4amZrZWhtc29mampmYW1qeHh4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY2MzQ5NjEsImV4cCI6MjA5MjIxMDk2MX0.Vd8WYqkdWzdqlEjFYG5UmXfV58doH5aIlvSW7gnJuM0"

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
